let isDialogVisible = false;

export default function showOfflineDialog($router, $route, $buefy, jobData) {
  console.log('showOfflineDialog called');
  if (isDialogVisible) return;

  isDialogVisible = true;

  $buefy.dialog.alert({
    title: 'Notice',
    message: `
        <div>
            This job is currently <b>unavailable</b> because it’s checked out for <b>offline work</b> by:<br>
            <i>${jobData.checkedOut}</i>
        </div>
    `,
    type: 'is-warning',
    hasIcon: true,
    icon: 'information',
    iconPack: 'mdi',
    ariaRole: 'alertdialog',
    confirmText: 'Return to Job List',
    ariaModal: true,
    onConfirm: () => {
      const module = $route.path.split('/')[2];
      const targetPath = `/view/${module}`;

      if ($route.path !== targetPath) {
        $router.push(targetPath);
      }

      isDialogVisible = false;
    },
    onCancel: () => {
      isDialogVisible = false;
    },
    onClose: () => {
      isDialogVisible = false;
    },
  });
}
